"use client";

import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import { CircleIcon } from "lucide-react";
import { motion } from "motion/react";
import React from "react";
import MotionHighlight from "@/components/effects/MotionHighlight";
import Flex from "@/components/layout/Flex";
import { breakpointClasses, cls, cn, splitBreakpointProps } from "@/lib/utils";
import type { DropdownMenuRadioItemProps } from "../types";

function DropdownMenuRadioItem({
  disabled,
  className = "",
  children,
  ...props
}: DropdownMenuRadioItemProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <MotionHighlight.Item disabled={disabled}>
      <DropdownMenuPrimitive.RadioItem {...native} asChild disabled={disabled}>
        <motion.div
          data-slot="dropdown-menu-radio-item"
          data-disabled={disabled}
          whileTap={{ scale: 0.95 }}
          className={cn(
            "[&:not([data-highlight])]:focus:bg-accent focus:text-accent-foreground relative flex cursor-default items-center gap-2 rounded-sm py-1.5 pr-2 pl-8 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
            className,
            classes,
          )}
        >
          <Flex
            as="span"
            className="pointer-events-none absolute left-2 size-3.5"
            direction="row"
            justify="center"
            items="center"
          >
            <DropdownMenuPrimitive.ItemIndicator>
              <CircleIcon className={cls`size-2 fill-current`} />
            </DropdownMenuPrimitive.ItemIndicator>
          </Flex>
          {children}
        </motion.div>
      </DropdownMenuPrimitive.RadioItem>
    </MotionHighlight.Item>
  );
}

DropdownMenuRadioItem.displayName = "DropdownMenu.RadioItem";

export default DropdownMenuRadioItem;
